import { createSafeContext } from 'core/Utils';

export type ExperimentsContextValue = {
  useOpenGlobalOnboarding?: () => { openLogin: (redirect: string) => void };
};

export const [ExperimentsProvider, useExperimentsContext] =
  createSafeContext<ExperimentsContextValue>('Experiment component was not found in tree');
